import React, { Component } from 'react';
import '../../../App.css';
import '../../../styles/app-demo.css';
import Calendar from 'react-calendar';
import Moment from 'react-moment';

class BillPayDate extends Component {

  constructor(props){
    super(props)
    this.state = {
      date: new Date()
    }
    this.submitDate = this.submitDate.bind(this);
    this.handleDate = this.handleDate.bind(this);
  }

  handleDate = date => this.setState({ date })

  submitDate() {
    this.props.submitDate(this.state.date)
    this.props.handleBillPayRoute('confirm payment')
  }

  render() {

    return (
      <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <i onClick={() => this.props.handleBillPayRoute('payment frequency')} className="fa fa-angle-left"></i>
            <h2>Send On Date</h2>
          </div>
          <div className="mobile-app-dashboard">
            <div className="mobile-app-dashboard">
              <div id="payment-date">
                <Moment format="MM/DD/YYYY">
                  {this.state.date}
                </Moment>
              </div>
              <div id="payment-calendar">
                <Calendar
                  minDate={new Date()}
                  onChange={this.handleDate}
                  value={this.state.date}
                />
              </div>
              <button className="bill-pay-button" onClick={this.submitDate}>CONTINUE</button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default BillPayDate;
